import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar";
import ProductHeader from "../../component/ProductHeader";
import Footer from "../../component/Footer";
import Images from "../../assets/Image";
import { FaDownload } from "react-icons/fa";
import ContactUsFooter from "../../component/ContactUsFooter";
import MostlyViewed from "../../component/MostlyViewed";
import FilePdf from "../../broucherPdf/filePdf";
import SpecificationViewed from "../../component/SepcificationViewed";
import copilot128 from "../../assets/uspcopilot128.png"
import copilot256 from "../../assets/uspcopilot256.png"

export default function CopilotAll() {
  const [specificationVisible, setSpecificationVisible] = useState(false);
  const [youtubeVideoVisible, setYoutubeVideoVisible] = useState(false);
  const [printerDetailsVisible, setPrinterDetailsVisible] = useState(false);
  const containerRef = useRef(null);
  const youtubeContainerRef = useRef(null);
  const printerDetailsRef = useRef(null);

  // Unified specifications for both models with inline labels
  const leftSidePrinterSpecification = [
    {
      title: "Print Technology",
      data: "Piezo impulse printhead technology",
    },
    {
      title: "Maximum Print Height",
      data: "CoPilot 128: 0.7\" (18mm) per printhead; CoPilot 256: 1.4\" (35mm) per printhead",
    },
    {
      title: "Vertical Print Resolution",
      data: "185 dpi capable of printing razor-sharp graphics, small character text and scannable bar codes",
    },
    {
      title: "Horizontal Print Resolution",
      data: "205 dpi",
    },
    {
      title: "Print Speed",
      data: "Up to 135 ft/min (41 Mtrs/min) @ 205 dpi",
    },
    {
      title: "Time & Date",
      data: "Internal real time clock with battery back-up",
    },
  ];

  const rightSidePrinterSpecification = [
    {
      title: "Product Sensor",
      data: "External diffuse beam photocell standard",
    },
    {
      title: "Communication Interface",
      data: "One USB host and one Ethernet input",
    },
    {
      title: "Touchscreen - Display",
      data: "4.3\" (10.9 cm) full color touchscreen display",
    },
    {
      title: "Ink Cartridge Volume",
      data: "500ml cartridge or bag",
    },
    {
      title: "Low Ink Indicator",
      data: "Message alert on touchscreen; alarm beacon optional",
    },
    {
      title: "Substrate Capabilities",
      data: "Porous or Non-Porous surfaces",
    },
    {
      title: "Electrical Requirements",
      data: "100 - 240 VAC, 50/60 Hz",
    },
    {
      title: "Operating Environment",
      data: "34°F to 104°F (1°C to 40°C)",
    },
    {
      title: "Agency Certifications",
      data: "CE, TUV pending",
    },
  ];

  const foodAndBeverage1 = [
    {
      productImg: Images?.industry5,
      label: "Food & Beverage",
      pageNavigate: "/byindustry/foodandbeverage",
    },
    {
      productImg: Images?.industry1,
      label: "Automobile",
      pageNavigate: "/byindustry/automobile",
    },
    {
      productImg: Images?.industry7,
      label: "Pharma",
      pageNavigate: "/byindustry/pharma",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSpecificationVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setYoutubeVideoVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (youtubeContainerRef.current) {
      observer.observe(youtubeContainerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPrinterDetailsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (printerDetailsRef.current) {
      observer.observe(printerDetailsRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const downloadLinkRef = useRef(null);

  const handleDivClick = () => {
    if (downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  };

  return (
    <div>
      <Navbar />
      <ProductHeader
        headerTxt="COPILOT 128-256"
        printerImg={Images?.uspstream6}
        pdfFile={FilePdf?.usp_COPILOt_128_256}
      />
      <div className="printerPageContainer">
        <div className="printerDetailsContainer">
          <header
            className={`printerDetailsHeader ${printerDetailsVisible ? "animated" : ""
              }`}
          >
            CO PILOT 128 & 256
          </header>
          <div
            ref={printerDetailsRef}
            className={`printerDetailsData ${printerDetailsVisible ? "animated" : ""
              }`}
          >
            <p style={{ marginBottom: "15px" }}>
              Squid Ink's CoPilot 128 and 256 printing systems are so designed as to print superior quality hi-resolution characters of either porous or non-porous surfaces. With up to 0.7" (128) and 1.4" (256) of print height per printhead and the ability to run up to 2 printheads from one controller, these offer a versatile yet cost-effective solution for your business.
            </p>

            <p style={{ marginBottom: "15px" }}>
              Both the CoPilot 128 and 256 variants feature a 4.3" full-color touchscreen that provides access to the system's internal messages and print functions. Messages are created and edited on Squid Ink's easy-to-use Orion™ PC Software and transferred via Ethernet or USB device. For larger applications, a virtually unlimited number of printing systems can be connected via Ethernet and controlled through one central Orion™ print station.
            </p>

            <p style={{ marginBottom: "15px" }}>
              Both the CoPilot 128 and 256 are designed to meet the harsh demands of your application, featuring a durable touchscreen, industrial strength printhead construction and print engines designed for industrial applications. You can be confident that their rugged design will withstand the most abusive industrial environments while providing superior print quality. These two CoPilot variants also feature a large 500ml cartridge or bag ink system. The generous ink volume allows users to keep their line running, reducing downtime and maximizing ROI.
            </p>

            <p>
              As new additions to Squid Ink's growing family of marking and coding systems, the CoPilot 128 and 256 let users meet the GS1 barcode specification. Any way you look at it, these unbeatable printers from Squid Ink provide users with an affordable solution to meet their inkjet coding needs.
            </p>
          </div>

          <div className="printerDetailsVideo" ref={youtubeContainerRef}>
            {/* <div className="printerYoutubeLink">
              <iframe
                className={`youtubeVideo ${youtubeVideoVisible ? "animated" : ""
                  }`}
                width="300"
                height="250"
                src="https://www.youtube.com/embed/jMFx1pUakkU?si=oDSbquQyGUGkTZEt"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style={{ borderRadius: "6px" }}
              ></iframe>
            </div> */}
            <div>
              <div
                className={`printerBrochure ${youtubeVideoVisible ? "animated" : ""
                  }`}
                style={{ cursor: "pointer" }}
                onClick={handleDivClick}
              >
                <div>
                  <div style={{ display: "flex", gap: "10px", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ flex: 1 }}>
                      <p style={{ textAlign: "center", fontWeight: "bold", marginBottom: "5px" }}>CoPilot 128</p>
                      <img
                        className="w-[100%]"
                        src={copilot128}
                        alt="CoPilot 128"
                        style={{ maxHeight: "150px" }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <p style={{ textAlign: "center", fontWeight: "bold", marginBottom: "5px" }}>CoPilot 256</p>
                      <img
                        className="w-[100%]"
                        src={copilot256}
                        alt="CoPilot 256"
                        style={{ maxHeight: "150px" }}
                      />
                    </div>
                  </div>
                  {/* Buttons */}
                  <div className="brochureImageButtons">
                    <button className="downloadBrochureBtn">
                      Download Brochure
                    </button>
                  </div>
                  <a
                    href={FilePdf?.usp_COPILOt_128_256}
                    download="Usp COPILOT_128-256"
                    ref={downloadLinkRef}
                    style={{ display: "none" }}
                  >
                    Download Brochure
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="printerSpecificationContainer">
          <header className="printerDetailsHeader">Specification</header>
          <div
            ref={containerRef}
            className="printerSpecificationDetailsContainer"
          >
            <div className="leftSideSpecificationContainer">
              {leftSidePrinterSpecification.map((item, index) => (
                <div
                  className={`specificationDetails ${specificationVisible ? "animated" : ""
                    }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
            <div className="rightSideSpecificationContainer">
              {rightSidePrinterSpecification.map((item, index) => (
                <div
                  className={`rightSpecificationDetails ${specificationVisible ? "animated" : ""
                    }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <SpecificationViewed foodAndBeverage1={foodAndBeverage1} />

        <MostlyViewed />
      </div>
      <ContactUsFooter />
      <Footer />
    </div>
  );
}
